import companyQueries from "$/lib/queries/company-queries"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const paramsSchema = z.object({
  companyId: z.string().uuid(),
})

export const Route = createFileRoute(
  "/(app)/_auth/settings/companies/$companyId",
)({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ companyId }) => ({ companyId: `${companyId}` }),
  },
  loader: async ({ context: { queryClient }, params }) => {
    const company = await queryClient.fetchQuery(
      companyQueries.detail(params.companyId),
    )
    return {
      crumbs: company.name,
    }
  },
})
